// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"d53365e7","208":"39029024","335":"243e7160","506":"3d312398","534":"49ca0032","607":"b5d7606d","644":"215e4433","663":"99ebda8f","831":"e66c58fb"}[chunkId] + ".chunk.js";
};